/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignVehiclesToSubscription } from '../fn/subscriptions/assign-vehicles-to-subscription';
import { AssignVehiclesToSubscription$Params } from '../fn/subscriptions/assign-vehicles-to-subscription';
import { createAuthSupportVehicle } from '../fn/authorization-supports/create-auth-support-vehicle';
import { CreateAuthSupportVehicle$Params } from '../fn/authorization-supports/create-auth-support-vehicle';
import { createVehicle } from '../fn/vehicles/create-vehicle';
import { CreateVehicle$Params } from '../fn/vehicles/create-vehicle';
import { deleteAuthSupportVehicle } from '../fn/authorization-supports/delete-auth-support-vehicle';
import { DeleteAuthSupportVehicle$Params } from '../fn/authorization-supports/delete-auth-support-vehicle';
import { deleteVehicle } from '../fn/vehicles/delete-vehicle';
import { DeleteVehicle$Params } from '../fn/vehicles/delete-vehicle';
import { exportSubscriptionVehicles } from '../fn/subscriptions/export-subscription-vehicles';
import { ExportSubscriptionVehicles$Params } from '../fn/subscriptions/export-subscription-vehicles';
import { exportVehicleDefinition } from '../fn/vehicles/export-vehicle-definition';
import { ExportVehicleDefinition$Params } from '../fn/vehicles/export-vehicle-definition';
import { getAuthSupportVehicle } from '../fn/authorization-supports/get-auth-support-vehicle';
import { GetAuthSupportVehicle$Params } from '../fn/authorization-supports/get-auth-support-vehicle';
import { getTransactionsOfVehicle } from '../fn/transactions/get-transactions-of-vehicle';
import { GetTransactionsOfVehicle$Params } from '../fn/transactions/get-transactions-of-vehicle';
import { getVehicle } from '../fn/vehicles/get-vehicle';
import { GetVehicle$Params } from '../fn/vehicles/get-vehicle';
import { getVehicles } from '../fn/vehicles/get-vehicles';
import { GetVehicles$Params } from '../fn/vehicles/get-vehicles';
import { getVehiclesOfSubscription } from '../fn/subscriptions/get-vehicles-of-subscription';
import { GetVehiclesOfSubscription$Params } from '../fn/subscriptions/get-vehicles-of-subscription';
import { importSubscriptionVehicles } from '../fn/subscriptions/import-subscription-vehicles';
import { ImportSubscriptionVehicles$Params } from '../fn/subscriptions/import-subscription-vehicles';
import { importVehicleDefinition } from '../fn/vehicles/import-vehicle-definition';
import { ImportVehicleDefinition$Params } from '../fn/vehicles/import-vehicle-definition';
import { removeVehiclesToSubscription } from '../fn/subscriptions/remove-vehicles-to-subscription';
import { RemoveVehiclesToSubscription$Params } from '../fn/subscriptions/remove-vehicles-to-subscription';
import { TransactionPagedList } from '../models/transaction-paged-list';
import { updateAuthSupportVehicle } from '../fn/authorization-supports/update-auth-support-vehicle';
import { UpdateAuthSupportVehicle$Params } from '../fn/authorization-supports/update-auth-support-vehicle';
import { updateVehicle } from '../fn/vehicles/update-vehicle';
import { UpdateVehicle$Params } from '../fn/vehicles/update-vehicle';
import { userAddVehicles } from '../fn/subscriptions/user-add-vehicles';
import { UserAddVehicles$Params } from '../fn/subscriptions/user-add-vehicles';
import { userRemoveVehicles } from '../fn/subscriptions/user-remove-vehicles';
import { UserRemoveVehicles$Params } from '../fn/subscriptions/user-remove-vehicles';
import { Vehicle } from '../models/vehicle';
import { vehicleAddAuthSupport } from '../fn/subscriptions/vehicle-add-auth-support';
import { VehicleAddAuthSupport$Params } from '../fn/subscriptions/vehicle-add-auth-support';
import { VehiclePagedList } from '../models/vehicle-paged-list';
import { vehicleRemoveAuthSupport } from '../fn/subscriptions/vehicle-remove-auth-support';
import { VehicleRemoveAuthSupport$Params } from '../fn/subscriptions/vehicle-remove-auth-support';


/**
 * All about the vehicles
 */
@Injectable({ providedIn: 'root' })
export class VehiclesService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userAddVehicles()` */
  static readonly UserAddVehiclesPath = '/subscriptions/{uid}/users/{userUid}/vehicles/assign';

  /**
   * Add vehicles to a subscription and an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAddVehicles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddVehicles$Response(params: UserAddVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userAddVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Add vehicles to a subscription and an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAddVehicles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddVehicles(params: UserAddVehicles$Params, context?: HttpContext): Observable<void> {
    return this.userAddVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRemoveVehicles()` */
  static readonly UserRemoveVehiclesPath = '/subscriptions/{uid}/users/{userUid}/vehicles/remove';

  /**
   * Remove vehicles from a subscription and an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRemoveVehicles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveVehicles$Response(params: UserRemoveVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userRemoveVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove vehicles from a subscription and an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRemoveVehicles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveVehicles(params: UserRemoveVehicles$Params, context?: HttpContext): Observable<void> {
    return this.userRemoveVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVehiclesOfSubscription()` */
  static readonly GetVehiclesOfSubscriptionPath = '/subscriptions/{uid}/vehicles';

  /**
   * Retrieve a list of vehicles of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVehiclesOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehiclesOfSubscription$Response(params: GetVehiclesOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<VehiclePagedList>> {
    return getVehiclesOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of vehicles of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVehiclesOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehiclesOfSubscription(params: GetVehiclesOfSubscription$Params, context?: HttpContext): Observable<VehiclePagedList> {
    return this.getVehiclesOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehiclePagedList>): VehiclePagedList => r.body)
    );
  }

  /** Path part for operation `assignVehiclesToSubscription()` */
  static readonly AssignVehiclesToSubscriptionPath = '/subscriptions/{uid}/vehicles/assign';

  /**
   * Assign vehicle to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignVehiclesToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignVehiclesToSubscription$Response(params: AssignVehiclesToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignVehiclesToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign vehicle to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignVehiclesToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignVehiclesToSubscription(params: AssignVehiclesToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.assignVehiclesToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeVehiclesToSubscription()` */
  static readonly RemoveVehiclesToSubscriptionPath = '/subscriptions/{uid}/vehicles/remove';

  /**
   * Remove vehicles from plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeVehiclesToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeVehiclesToSubscription$Response(params: RemoveVehiclesToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeVehiclesToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove vehicles from plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeVehiclesToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeVehiclesToSubscription(params: RemoveVehiclesToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.removeVehiclesToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionVehicles()` */
  static readonly ExportSubscriptionVehiclesPath = '/subscriptions/{uid}/vehicles/export';

  /**
   * Export the vehicles and auth supports of a subscription.
   *
   * Allows to export the Subscription vehicles and auth supports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionVehicles()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionVehicles$Response(params: ExportSubscriptionVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the vehicles and auth supports of a subscription.
   *
   * Allows to export the Subscription vehicles and auth supports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionVehicles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionVehicles(params: ExportSubscriptionVehicles$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importSubscriptionVehicles()` */
  static readonly ImportSubscriptionVehiclesPath = '/subscriptions/{uid}/vehicles/import';

  /**
   * Import the vehicles and auth supports of a subscription.
   *
   * Allows to import the vehicles and auth supports of a subscription plan, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importSubscriptionVehicles()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importSubscriptionVehicles$Response(params: ImportSubscriptionVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importSubscriptionVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the vehicles and auth supports of a subscription.
   *
   * Allows to import the vehicles and auth supports of a subscription plan, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importSubscriptionVehicles$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importSubscriptionVehicles(params: ImportSubscriptionVehicles$Params, context?: HttpContext): Observable<void> {
    return this.importSubscriptionVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleAddAuthSupport()` */
  static readonly VehicleAddAuthSupportPath = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/assign';

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleAddAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupport$Response(params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleAddAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleAddAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupport(params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.vehicleAddAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleRemoveAuthSupport()` */
  static readonly VehicleRemoveAuthSupportPath = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/remove';

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleRemoveAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupport$Response(params: VehicleRemoveAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleRemoveAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleRemoveAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupport(params: VehicleRemoveAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.vehicleRemoveAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVehicles()` */
  static readonly GetVehiclesPath = '/vehicles/search';

  /**
   * Retrieve a list of vehicles, with pagination, sort and search.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVehicles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehicles$Response(params?: GetVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<VehiclePagedList>> {
    return getVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of vehicles, with pagination, sort and search.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVehicles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehicles(params?: GetVehicles$Params, context?: HttpContext): Observable<VehiclePagedList> {
    return this.getVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehiclePagedList>): VehiclePagedList => r.body)
    );
  }

  /** Path part for operation `createVehicle()` */
  static readonly CreateVehiclePath = '/vehicles';

  /**
   * Create a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVehicle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVehicle$Response(params: CreateVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVehicle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVehicle(params: CreateVehicle$Params, context?: HttpContext): Observable<void> {
    return this.createVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVehicle()` */
  static readonly GetVehiclePath = '/vehicles/{uid}';

  /**
   * Retrieve a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehicle$Response(params: GetVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
    return getVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehicle(params: GetVehicle$Params, context?: HttpContext): Observable<Vehicle> {
    return this.getVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vehicle>): Vehicle => r.body)
    );
  }

  /** Path part for operation `updateVehicle()` */
  static readonly UpdateVehiclePath = '/vehicles/{uid}';

  /**
   * Update a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVehicle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVehicle$Response(params: UpdateVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVehicle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVehicle(params: UpdateVehicle$Params, context?: HttpContext): Observable<void> {
    return this.updateVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteVehicle()` */
  static readonly DeleteVehiclePath = '/vehicles/{uid}';

  /**
   * Delete a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVehicle$Response(params: DeleteVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVehicle(params: DeleteVehicle$Params, context?: HttpContext): Observable<void> {
    return this.deleteVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importVehicleDefinition()` */
  static readonly ImportVehicleDefinitionPath = '/vehicles/import';

  /**
   * Import the the Vehicles Definition.
   *
   * Allows to import the Vehicles Definition, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importVehicleDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importVehicleDefinition$Response(params?: ImportVehicleDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importVehicleDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the the Vehicles Definition.
   *
   * Allows to import the Vehicles Definition, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importVehicleDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importVehicleDefinition(params?: ImportVehicleDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importVehicleDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportVehicleDefinition()` */
  static readonly ExportVehicleDefinitionPath = '/vehicles/export';

  /**
   * Export the Vehicles Definition.
   *
   * Allows to export the the Vehicles Definition.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportVehicleDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportVehicleDefinition$Response(params?: ExportVehicleDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportVehicleDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the Vehicles Definition.
   *
   * Allows to export the the Vehicles Definition.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportVehicleDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportVehicleDefinition(params?: ExportVehicleDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportVehicleDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfVehicle()` */
  static readonly GetTransactionsOfVehiclePath = '/vehicles/{uid}/transactions';

  /**
   * List the transactions of a vehicle, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfVehicle$Response(params: GetTransactionsOfVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * List the transactions of a vehicle, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfVehicle(params: GetTransactionsOfVehicle$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `getAuthSupportVehicle()` */
  static readonly GetAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * get a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportVehicle$Response(params: GetAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
    return getAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * get a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportVehicle(params: GetAuthSupportVehicle$Params, context?: HttpContext): Observable<Vehicle> {
    return this.getAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vehicle>): Vehicle => r.body)
    );
  }

  /** Path part for operation `updateAuthSupportVehicle()` */
  static readonly UpdateAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * Update a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuthSupportVehicle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportVehicle$Response(params: UpdateAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuthSupportVehicle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportVehicle(params: UpdateAuthSupportVehicle$Params, context?: HttpContext): Observable<void> {
    return this.updateAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAuthSupportVehicle()` */
  static readonly CreateAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * Create a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuthSupportVehicle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportVehicle$Response(params: CreateAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuthSupportVehicle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportVehicle(params: CreateAuthSupportVehicle$Params, context?: HttpContext): Observable<void> {
    return this.createAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAuthSupportVehicle()` */
  static readonly DeleteAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * Delete a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthSupportVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportVehicle$Response(params: DeleteAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthSupportVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportVehicle(params: DeleteAuthSupportVehicle$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
